import { resetPassword, ResetPasswordPayload } from "@/api/forgot-password";
import { MutationOptionsWithoutFn } from "@/types/types";
import { useMutation } from "@tanstack/react-query";
import { VerifyCodeResponse } from "./schema";

export const useResetPassword = (
	options?: MutationOptionsWithoutFn<VerifyCodeResponse, ResetPasswordPayload>,
) => {
	return useMutation({
		mutationFn: resetPassword,
		...options,
	});
};
